(function () {
  var specialDates = [
    '2026-01-19', '2026-02-16', '2026-05-25', '2026-06-19', '2026-07-03', '2026-09-07', '2026-10-12', '2026-11-11', '2026-11-26', '2026-11-27', '2026-12-24', '2026-12-25', '2026-12-31', '2027-01-01' // Add dates here
  ];
  var now = new Date();
  var gmtHours = -now.getTimezoneOffset() / 60;
  now.setHours(now.getHours() - gmtHours); // Convert to GMT
  now.setHours(now.getHours() - 7); // Convert to GMT-7 (Arizona)

  function isSpecialDate(currentDate) {
    var currentDateString = currentDate.toISOString().split('T')[0];
    return specialDates.includes(currentDateString);
  }

  if (now.getHours() >= 12 ||
    now.getDay() === 6 || // Saturday
    now.getDay() === 0 || // Sunday
    isSpecialDate(now)
  ) {
    var style = document.createElement('style');
    style.innerHTML = 'delm-widget { display: none!important; }';
    document.head.appendChild(style);
  }
})();